export enum ReportMetric {
  Sales = 'sales',
  Redemptions = 'redemptions',
  Expired = 'expired',
  Cancellations = 'cancellations',
}
export enum ReportMetricTickets {
  Sales = 'sales',
  Redemptions = 'redemptions',
  Cancellations = 'cancellations',
}

export enum ReportMetricType {
  Value = 'value',
  Volume = 'volume',
}

export enum ReportItemisation {
  Name = 'item',
  Type = 'type',
  DispatchMethod = 'dispatchFormat',
}

export interface ReportDateRange {
  selected: string
  previous: string
}

export interface HistoricReportItem {
  value: number
  volume: number
}
export interface IHistoricData {
  label: string
  sales: HistoricReportItem
  redemptions: HistoricReportItem
  expired: HistoricReportItem
  cancellations: HistoricReportItem
}

export interface IItemisedData {
  label: string
  total: number
}

export interface IItemisedReportResponse {
  total: number
  itemisedData: IItemisedData[]
}

export interface IGraphData {
  label: string
  total: number
}

export interface ISeries {
  label: string
  data: IGraphData[]
}

export interface IOverviewParams {
  overviewMetric: ReportMetric
  overviewMetricType: ReportMetricType
  overviewFromMonth: number
  overviewFromYear: number
}

export interface IBreakdownParams {
  breakdownMetric: ReportMetric
  breakdownItemiseBy: ReportItemisation
  breakdownMetricType: ReportMetricType
  breakdownFromDate: number
  breakdownToDate: number
}
